import { render, staticRenderFns } from "./Index.vue?vue&type=template&id=884f0e60&"
import script from "./Index.vue?vue&type=script&lang=js&"
export * from "./Index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Volumes/Development/2020/invoicing/crater-20201222/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('884f0e60')) {
      api.createRecord('884f0e60', component.options)
    } else {
      api.reload('884f0e60', component.options)
    }
    module.hot.accept("./Index.vue?vue&type=template&id=884f0e60&", function () {
      api.rerender('884f0e60', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/views/projects/Index.vue"
export default component.exports